export default "__VITE_ASSET__Dv5sX38R__"